import { webpush as API } from '../../api'
import { base64 } from '../../utils'

// initial state
const state = {
  initialized: false,
  enabled: false,
  error: "",
  subscribed: undefined,
}

// getters
const getters = {
  enabled: state => state.enabled,
  error: state => state.error,
  subscribed: state => state.subscribed,
}

// actions
const actions = {
  enable({ commit, getters }, enabled) {
    if(enabled && !getters.enabled) commit('ENABLE', enabled)
  },

  error({ dispatch, commit }, message) {
    // dispatch('failed', { message }, { root: true })
    console.warn(message);
    commit('ERROR', message)
  },

  registerServiceWorker({ dispatch, commit, state }) {
    if(state.initialized) return
    commit('INITIALIZED', true)
    if(!('serviceWorker' in navigator)) {
      dispatch('error', 'Service workers aren\'t supported in this browser.')
      return
    }
    if(!('PushManager' in window)) {
      dispatch('error', 'No Push API Support!')
      return
    }
    navigator.serviceWorker.register('/sw.js').then(registration => {
      // zakomentowany kod nie działa
      // if(state.enabled) initialiseServiceWorker()
      // else registration.unregister().then(boolean => console.log('unregistered'))
      initialiseServiceWorker(dispatch)
    })
  },

  status({ dispatch, commit }, status) {
    commit('STATUS', status)
    if(status.subscribed !== false) dispatch('subscribe')
  },

  /**
   * Subscribe for push notifications.
   */
  subscribe({ getters, dispatch }) {
    // console.log('subscribe', getters.enabled, vapid);
    if(!getters.enabled || !vapid) return
    // console.error('subscribe?')
    navigator.serviceWorker.ready.then(registration => {
      const options = { userVisibleOnly: true }
      if(vapid) options.applicationServerKey = base64.urlBase64ToUint8Array(vapid)
      registration.pushManager.subscribe(options)
        .then(subscription => {
          dispatch('enable', true)
          updateSubscription(subscription, dispatch)
        })
        .catch(e => {
          if(Notification.permission === 'denied') {
            dispatch('error', 'Permission for notifications was denied')
          }
          else {
            console.error(e);
            dispatch('error', 'Unable to subscribe to webpush notifications.', e)
          }
        })
    })
  },
  /**
   * Unsubscribe from push notifications.
   */
  unsubscribe({ dispatch, commit }) {
    console.error('unsubscribe');
    navigator.serviceWorker.ready.then(registration => {
      registration.pushManager.getSubscription().then(subscription => {
        // registration.unregister().then(boolean => console.log('unregistered service worker'))
        if(!subscription) {
          commit('SUBSCRIBED', false)
          return
        }
        subscription.unsubscribe().then(() => {
          commit('SUBSCRIBED', false)
          deleteSubscription(subscription)
        }).catch(e => {
          commit('SUBSCRIBED', false)
          dispatch('error', 'Unsubscription error: ', e)
        })
      }).catch(e => {
        dispatch('error', 'Error thrown while unsubscribing.', e)
      })
    })
  },
}

// mutations
const mutations = {
  INITIALIZED(state, status) {
    state.initialized = status
  },
  ENABLE(state, enabled) {
    state.enabled = enabled
  },
  ERROR(state, error) {
    state.error = error
  },
  STATUS(state, status) {
    vapid = status.vapid
    state.subscribed = status.subscribed
  },
  SUBSCRIBED(state, subscribed) {
    state.subscribed = subscribed
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}




let vapid, updated

import store from '../'

function initialiseServiceWorker(dispatch) {
  if(!('showNotification' in ServiceWorkerRegistration.prototype)) {
    store.dispatch('webpush/error', 'Notifications aren\'t supported.')
    return
  }
  if(Notification.permission === 'denied') {
    store.dispatch('webpush/error', 'The user has blocked notifications.')
    return
  }
  if(!('PushManager' in window)) {
    store.dispatch('webpush/error', 'Push messaging isn\'t supported.')
    return
  }
  navigator.serviceWorker.ready.then(registration => {
    registration.pushManager.getSubscription()
      .then(subscription => {
        // console.log('initialiseServiceWorker done!', subscription);
        store.dispatch('webpush/enable', true)
        // console.log(subscription, store);
        if(store.getters['webpush/subscribed'] !== false) {
          if(subscription) updateSubscription(subscription, dispatch)
          else             store.dispatch('webpush/subscribe')
        }
      })
      .catch(e => {
        store.dispatch('webpush/error', 'Error during getSubscription()')
      })
  })
}
/**
 * Send a request to the server to update user's subscription.
 * @param {PushSubscription} subscription
 */
function updateSubscription(subscription, dispatch) {
  if(updated) return
  store.commit('webpush/SUBSCRIBED', true)
  const key = subscription.getKey('p256dh')
  const token = subscription.getKey('auth')
  const data = {
    endpoint: subscription.endpoint,
    key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
    token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
  }
  API.updateSubscription(data)
    // .then(response => console.log('update subscription', response))
    .catch(failed => dispatch('error', failed))

  updated = true
}
/**
 * Send a requst to the server to delete user's subscription.
 * @param {PushSubscription} subscription
 */
function deleteSubscription(subscription) {
  updated = false
  API.deleteSubscription({ endpoint: subscription.endpoint })
    // .then(response => console.log('delete subscription', response))
    .catch(failed => store.dispatch('error', failed))
 }